/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import {
  clearCompanyData,
  clearFormQuote,
  clearQuotesByCompany,
  clearRequestState,
  getQuotes,
  updateQuoteJunto,
  updateQuotePottencial,
  setResumeProcess,
  setFormQuote,
  clearResumeProcess,
  clearSearchCompanyData,
  clearSecondQuoteTry,
  clearCurrentProcessId,
  updateQuoteSombrero,
  updateQuoteAvla,
} from 'store/modules/conlicitaseg_store/actions';
import { ConlicitasegState, InsuranceProcess } from 'store/modules/conlicitaseg_store/types';
import ModalConlicitasegEmail from 'components/atoms/modal_conlicitaseg_email';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { downloadFile, sendInsuranceQuoteToEmail } from 'services/actions/conlicitaseg_actions';
import { ProfileState } from 'store/modules/profile_store/types';
import Loader from 'components/atoms/loader';
import createTrack from 'services/actions/tracker_actions';
import { formatCurrency, formatCNPJ, formatDate, STATUS_LABEL_MAP } from 'services/conlicitaseg';
import OpenTutorial from 'components/atoms/open_tutorial';
import ConlicitacaoPromoBanner from 'components/molecules/conlicitacao_promo_banner';
import ConlicitasegOnlyPromoModal from 'components/molecules/conlicitaseg_only_promo_modal';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { ClearButton, StateIcon, StatusBadge } from './styles';

const PROMO_BANNER_SOURCE = 'Banner ConlicitaSeg';

interface StatusCounts {
  [key: string]: number;
}

const Conlicitaseg: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { processes, request } = useSelector<ApplicationState, ConlicitasegState>(
    (state) => state.session.conlicitaseg,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [localProcess, setLocalProcess] = useState<Array<InsuranceProcess>>([]);
  const [statusFilter, setStatusFilter] = useState<string>('Todos');
  const [cnpjFilter, setCnpjFilter] = useState<string>('Todos');
  const [search, setSearch] = useState<string>('');
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false);
  const [newEmail, setNewEmail] = useState<string>('');
  const [emails, setEmails] = useState<string[]>([]);
  const [selectedInsurance, setSelectedInsurance] = useState<InsuranceProcess | null>(null);
  const isOnlyConlicitaseg = useOnlyConlicitaseg();
  const [showPromoModal, setShowPromoModal] = useState<boolean>(false);

  const isAnyQuoteLoading =
    request?.create_quote_by_company?.junto?.loading ||
    request?.create_quote_by_company?.pottencial?.loading ||
    request?.create_quote_by_company?.sombrero?.loading ||
    request?.create_quote_by_company?.avla?.loading;

  useEffect(() => {
    dispatch(getQuotes());
    dispatch(clearFormQuote());
    dispatch(clearQuotesByCompany());
    dispatch(clearCompanyData());
    dispatch(clearResumeProcess());
    dispatch(clearSearchCompanyData());
    dispatch(clearCurrentProcessId());
    dispatch(clearSecondQuoteTry());
    if (!isAnyQuoteLoading) {
      dispatch(clearRequestState());
    }
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(processes) && processes.length > 0) setLocalProcess(processes);
    else setLocalProcess([]);
  }, [processes]);

  const statusOptions = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Cotação', label: 'Cotações' },
    { value: 'Em análise', label: 'Em análise' },
    { value: 'Emitida', label: 'Emitidas' },
    { value: 'Vigente', label: 'Vigentes' },
    { value: 'Encerrada', label: 'Encerradas' },
    { value: 'Cancelada', label: 'Canceladas' },
    { value: 'Recusada', label: 'Recusadas' },
    { value: 'Expirada', label: 'Expiradas' },
  ];

  const statusCounts = localProcess?.reduce((acc, insurance) => {
    const statusName = STATUS_LABEL_MAP[insurance?.status] || insurance.status || '';
    acc[statusName] = (acc[statusName] || 0) + 1;
    return acc;
  }, {} as StatusCounts);
  const totalCount = localProcess?.length;

  const filteredInsurance = localProcess
    ?.filter((insurance) => {
      const statusName = STATUS_LABEL_MAP[insurance?.status] || insurance.status;
      const isStatusValid = statusFilter === 'Todos' || statusName === statusFilter;
      const isCnpjValid = cnpjFilter === 'Todos' || insurance?.policyholder_cnpj === cnpjFilter;
      const isSearchValid =
        !search ||
        insurance?.policyholder_company_name?.toLowerCase().includes(search.toLowerCase()) ||
        insurance?.bidding_edict?.includes(search) ||
        insurance?.selected_quote?.selected_api_quote_id?.toString().includes(search);
      return isStatusValid && isCnpjValid && isSearchValid;
    })
    ?.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

  const statusSelectOptions = statusOptions?.map((option) => ({
    value: option.value,
    label: `${option.label} (${
      option.value === 'Todos' ? totalCount : statusCounts[option.value] || 0
    })`,
  }));

  const getActionsForStatus = (insurance: InsuranceProcess) => {
    const statusName = STATUS_LABEL_MAP[insurance?.status] || insurance?.status;
    const isPolicyDisabled = !insurance?.selected_quote?.document_url;
    const isBillDisabled = !insurance?.selected_quote?.bill_url;
    const isEmailDisabled =
      !insurance?.selected_quote?.document_url || !insurance?.selected_quote?.bill_url;

    if (!insurance?.internal_process) {
      return [{ label: 'Ver processo', action: 'ver-processo', disabled: false }];
    }

    switch (statusName) {
      case 'Cotação':
        return [{ label: 'Retomar processo', action: 'retomar-processo', disabled: false }];
      case 'Em análise':
        return [{ label: 'Ver processo', action: 'ver-processo', disabled: false }];
      case 'Cancelada':
        return [{ label: 'Ver processo', action: 'ver-processo', disabled: false }];
      case 'Vigente':
        return [
          { label: 'Ver processo', action: 'ver-processo', disabled: false },
          { label: 'Baixar apólice', action: 'baixar-apolice', disabled: isPolicyDisabled },
          { label: 'Enviar por email', action: 'enviar-email', disabled: isEmailDisabled },
          { label: 'Baixar boleto', action: 'baixar-boleto', disabled: isBillDisabled },
        ];
      case 'Emitida':
        return [
          { label: 'Ver processo', action: 'ver-processo', disabled: false },
          { label: 'Baixar apólice', action: 'baixar-apolice', disabled: isPolicyDisabled },
          { label: 'Enviar por email', action: 'enviar-email', disabled: isEmailDisabled },
          { label: 'Baixar boleto', action: 'baixar-boleto', disabled: isBillDisabled },
        ];
      case 'Recusada':
        return [
          { label: 'Ver processo', action: 'ver-processo', disabled: false },
          { label: 'Baixar apólice', action: 'baixar-apolice', disabled: isPolicyDisabled },
          { label: 'Enviar por email', action: 'enviar-email', disabled: isEmailDisabled },
        ];
      case 'Encerrada':
        return [
          { label: 'Ver processo', action: 'ver-processo', disabled: false },
          { label: 'Baixar apólice', action: 'baixar-apolice', disabled: isPolicyDisabled },
          { label: 'Enviar por email', action: 'enviar-email', disabled: isEmailDisabled },
        ];
      default:
        return [{ label: 'Ver processo', action: 'ver-processo', disabled: false }];
    }
  };

  const handleAddEmail = () => {
    if (newEmail && !emails.includes(newEmail)) {
      setEmails([...emails, newEmail]);
      setNewEmail('');
    }
  };

  const handleRemoveEmail = (emailToRemove: string) => {
    setEmails(emails.filter((email) => email !== emailToRemove));
  };

  const handleSendEmails = () => {
    if (selectedInsurance && selectedInsurance.selected_quote?.selected_api_quote_id) {
      emails.forEach((email) => {
        sendInsuranceQuoteToEmail(selectedInsurance.selected_quote.selected_api_quote_id, email);
      });
      setShowEmailModal(false);
      setNewEmail('');
      setSelectedInsurance(null);
    }
  };

  const handleAction = (action: string, insurance: InsuranceProcess) => {
    switch (action) {
      case 'baixar-minuta':
        downloadFile(insurance.selected_quote.id, 'minuta');
        break;
      case 'retomar-processo':
        dispatch(setResumeProcess(true));
        dispatch(setFormQuote(insurance));
        dispatch(clearQuotesByCompany());
        dispatch(updateQuoteJunto(insurance, profile.id, profile.clientId, insurance.id));
        dispatch(updateQuotePottencial(insurance, profile.id, profile.clientId, insurance.id));
        dispatch(updateQuoteSombrero(insurance, profile.id, profile.clientId, insurance.id));
        dispatch(updateQuoteAvla(insurance, profile.id, profile.clientId, insurance.id));
        history.push(`/conlicitaseg/cotacoes/${insurance.id}`);
        break;
      case 'ver-processo':
        history.push(`/conlicitaseg/processo/${insurance.id}/${insurance.id}`);
        break;
      case 'baixar-apolice':
        downloadFile(insurance.selected_quote.id, 'apolice');
        break;
      case 'enviar-email':
        setSelectedInsurance(insurance);
        setShowEmailModal(true);
        break;
      case 'baixar-boleto':
        downloadFile(insurance.selected_quote.id, 'boleto');
        break;
      default:
        break;
    }
  };

  const cnpjSelectOptions = [
    { value: 'Todos', label: 'Todos' },
    ...Array.from(new Set(localProcess?.map((insurance) => insurance?.policyholder_cnpj)))
      .filter(Boolean)
      .map((cnpj) => ({ value: cnpj, label: formatCNPJ(cnpj || '') })),
  ];

  const handleOpenPromoModal = () => {
    createTrack('ConlicitaSeg Only - Clicou em Conheça o Conlicitação', {
      fonte: PROMO_BANNER_SOURCE,
    });
    setShowPromoModal(true);
  };

  const handleNewQuote = () => {
    createTrack('ConlicitaSeg - Clicou no botão Nova Cotação');
    history.push('/conlicitaseg/novo');
  };

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions py-4">
        {!request?.get_quotes?.loaded && (
          <div className="row mb-3 mt-5">
            <div className="col text-center">
              <Loader />
            </div>
          </div>
        )}
        {request?.get_quotes?.loaded && (
          <>
            {isOnlyConlicitaseg && (
              <div className="row mt-5">
                <div className="col">
                  <ConlicitacaoPromoBanner onClick={handleOpenPromoModal} />
                </div>
              </div>
            )}
            <div className={`row align-items-center mb-3 ${isOnlyConlicitaseg ? 'mt-4' : 'mt-5'}`}>
              <div className="col-6">
                <div className="d-md-flex d-block align-items-center">
                  <h4 className="mb-0 mr-3">ConlicitaSeg</h4>
                  <OpenTutorial type="container" source="conlicitaseg" />
                </div>
              </div>
              <div className="col-6 text-right">
                <button type="button" className="btn btn-primary ml-2" onClick={handleNewQuote}>
                  Nova Cotação
                </button>
              </div>
            </div>
            <div className="row mb-3 align-items-end">
              <div className="col-md-3 mb-3 ">
                <label htmlFor="statusFilter" className="m-0 mb-2">
                  Filtrar por status
                </label>
                <Select
                  inputId="statusFilter"
                  className="pr-10"
                  value={statusSelectOptions?.find((option) => option?.value === statusFilter)}
                  onChange={(option) => setStatusFilter(option?.value || 'Todos')}
                  options={statusSelectOptions}
                  isSearchable={false}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="cnpjFilter" className="m-0 mb-2">
                  CNPJ do Tomador
                </label>
                <Select
                  inputId="cnpjFilter"
                  className="pr-10"
                  value={cnpjSelectOptions?.find((option) => option.value === cnpjFilter)}
                  onChange={(option) => setCnpjFilter(option?.value || 'Todos')}
                  options={cnpjSelectOptions}
                  isSearchable
                />
              </div>
              <div className="col-md-5 mb-3">
                <div className="position-relative">
                  <input
                    id="search"
                    type="text"
                    className="form-control pr-5"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Buscar uma cotação ou apólice"
                  />
                  <ClearButton
                    type="button"
                    className="btn btn-link position-absolute text-primary p-0 small"
                    onClick={() => setSearch('')}
                  >
                    Limpar
                  </ClearButton>
                </div>
              </div>
            </div>

            {filteredInsurance && filteredInsurance.length > 0 ? (
              filteredInsurance.map((insurance) => (
                <div key={insurance?.id} className="row mb-3">
                  <div className="col">
                    <Card className="p-3 shadow-sm rounded bg-white">
                      <div className="row">
                        <div className="col-8">
                          <span className="text-muted small mb-1">Segurado</span>
                          <div className="font-weight-bold mb-2">
                            {insurance?.insured.name} - {formatCNPJ(insurance?.insured.cnpj)}
                          </div>
                        </div>
                        <div className="col-4 text-right">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="primary"
                              id={`dropdown-acoes-${insurance?.selected_quote?.selected_api_quote_id}`}
                              disabled={insurance?.status === 'expirada'}
                            >
                              Ações
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {getActionsForStatus(insurance).map((action) => (
                                <Dropdown.Item
                                  key={action.action}
                                  disabled={action.disabled}
                                  onClick={() => handleAction(action.action, insurance)}
                                >
                                  {action.label}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>

                      <div className="row align-items-center w-100">
                        <div className="col-12 col-md-4 col-xl-2 d-flex flex-column align-items-start mb-2 mb-xl-0">
                          <span className="text-muted small mb-1">Status</span>
                          <StatusBadge statusType={insurance?.status}>
                            {STATUS_LABEL_MAP[insurance?.status]}
                          </StatusBadge>
                        </div>
                        <div className="col-12 col-md-4 col-xl-2 d-flex flex-column align-items-start mb-2 mb-xl-0">
                          <span className="text-muted small mb-1">CNPJ do tomador</span>
                          <span className="d-flex align-items-center">
                            {formatCNPJ(insurance?.policyholder_cnpj || '')}
                            <i
                              className="material-icons fs-6 text-primary ml-1 databalloon"
                              aria-label={
                                insurance?.policyholder_company_name || 'Informação sobre o tomador'
                              }
                              data-balloon-pos="up"
                            >
                              info
                            </i>
                          </span>
                        </div>
                        <div className="col-12 col-md-4 col-xl-2 d-flex flex-column align-items-start mb-2 mb-xl-0">
                          <span className="text-muted small mb-1">Modalidade</span>
                          <span>{insurance?.type_warranty_id}</span>
                        </div>
                        <div className="col-12 col-md-4 col-xl-2 d-flex flex-column align-items-start mb-2 mb-xl-0">
                          <span className="text-muted small mb-1">Vigência do seguro</span>
                          <span>{`${formatDate(insurance?.contract_start_date)} até ${formatDate(
                            insurance?.contract_end_date,
                          )}`}</span>
                        </div>
                        <div className="col-12 col-md-4 col-xl-2 d-flex flex-column align-items-start mb-2 mb-xl-0">
                          <span className="text-muted small mb-1">Número do edital</span>
                          <span>{insurance?.bidding_edict || '-'}</span>
                        </div>
                        <div className="col-12 col-md-4 col-xl-2 d-flex flex-column align-items-start mb-2 mb-xl-0">
                          <span className="text-muted small mb-1">Valor a ser segurado</span>
                          <span>{formatCurrency(insurance?.contract_insured_amount)}</span>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              ))
            ) : (
              <div className="row">
                <div className="col">
                  <div className="bg-white rounded shadow-sm p-4">
                    <div className="text-center">
                      <StateIcon
                        className="material-icons-outlined text-dark d-block mx-auto mb-2"
                        aria-label="Sem cotações."
                      >
                        folder_open
                      </StateIcon>
                      <p>Você ainda não tem cotações de seguro garantia.</p>
                      <p>
                        Faça sua primeira cotação{' '}
                        <button
                          type="button"
                          className="btn btn-link p-0 align-baseline"
                          onClick={() => history.push('/conlicitaseg/novo')}
                        >
                          clicando aqui
                        </button>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <ModalConlicitasegEmail
              showEmailModal={showEmailModal}
              setShowEmailModal={setShowEmailModal}
              newEmail={newEmail}
              setNewEmail={setNewEmail}
              emails={emails}
              handleAddEmail={handleAddEmail}
              handleRemoveEmail={handleRemoveEmail}
              handleSendEmails={handleSendEmails}
            />
            {isOnlyConlicitaseg && (
              <ConlicitasegOnlyPromoModal
                show={showPromoModal}
                onHide={() => setShowPromoModal(false)}
                source={PROMO_BANNER_SOURCE}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Conlicitaseg;
